import { Injectable } from '@angular/core';
import { DataService } from './data.service'; // adjust path to your DataService
import { Call, Device } from '@twilio/voice-sdk';

@Injectable({
  providedIn: 'root'
})
export class PhoneboxService {
  private device: any;
  private connection: any;
  private errorMsg: string = '';
  outgoingConnection!: Call;
  data: any = {};

  constructor(
    private dataService: DataService
  ) { }

  getDevice(): any {
    return this.device;
  }

  getConnection(): any {
    return this.connection;
  }

  getConnectionStatus(): string {
    return this.connection ? this.connection._status : '';
  }

  getDeviceStatus(): string {
    return this.device ? this.device._status : '';
  }

  getErrorMsg(): string {
    return this.errorMsg;
  }

  async setUp(): Promise<void> {
    // disconnect all
    if (this.connection) {
      this.cleanUp();
    }

    if (this.device) {
      return;
    }
    try {
      this.dataService.getTwilioToken().subscribe((tokenResp: any) => {
        this.initializeVoiceCall(tokenResp.token);
      })
    } catch (error) {
      console.error('PhoneboxService setup error:', error);
    }
  }

  initializeVoiceCall(token: string) {
    // Setup Twilio.Device
    this.device = new Device(token, {
      allowIncomingWhileBusy: true,
      enableImprovedSignalingErrorPrecision: true,
      // Set Opus as our preferred codec. Opus generally performs better, requiring less bandwidth and
      // providing better audio quality in restrained network conditions. Opus will be default in 2.0.
      codecPreferences: [Call.Codec.Opus, Call.Codec.PCMU],
    });

    this.device.on('ready', () => {
    });

    this.device.on('error', (error: any) => {
      this.errorMsg = error.message;
    });

    this.device.on('registered', () => {
    });

  }
  async connect(phoneNumber: string): Promise<void> {
    const number = phoneNumber;
    if (this.device) {
      const deviceOptions: Device.ConnectOptions = {
        params: {
          To: number,
        },
      };

      this.outgoingConnection = await this.device?.connect(deviceOptions);
      this.connection = this.outgoingConnection;

      this.outgoingConnection?.on('accept', () => {
        this.connection._status = 'open'; // connected
      });

       this.outgoingConnection?.on('connect', () => {
        this.connection._status = 'open'; // connected
      });

      this.outgoingConnection?.on('disconnect', () => {
        this.connection._status = 'closed'; // disconnected
        this.connection = null;
      });

      this.outgoingConnection?.on('error', (error) => {
        this.connection._status = 'closed'; // error → disconnected
      });

      this.outgoingConnection?.on('reject', () => {
        this.connection._status = 'closed'; // rejected = disconnected
      });

      this.outgoingConnection?.on('ringing', () => {
        this.connection._status = 'ringing'; // custom status
      });
    }
  }

  disconnect(): void {
    if (this.device && this.connection) {
      this.device.disconnectAll();
      this.connection = null;
    }
  }

  toggleMute(bool: boolean): void {
    if (this.connection) {
      this.connection.mute(bool);
    }
  }

  isMuted(): boolean {
    return this.connection && this.connection.isMuted();
  }

  cleanUp(): void {
    if (this.connection) {
      this.disconnect();
    }
  }
}
